import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About AfroStripes</h4>
          <p>Celebrating African beauty, culture, and fashion with authentic textiles and attire from across the continent.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#wrappers">Wrappers</a></li>
            <li><a href="#shoes">Shoes</a></li>
            <li><a href="#bags">Bags</a></li>
            <li><a href="#livestream">Livestream</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>
          <ul className="social-links">
            <li><a href="https://twitch.tv/afrostripes" target="_blank" rel="noopener noreferrer">🎮 Twitch</a></li>
            <li><a href="https://instagram.com/afro.stripes" target="_blank" rel="noopener noreferrer">📷 Instagram</a></li>
            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">👍 Facebook</a></li>
            <li><a href="https://twitter.com/Afrostripes" target="_blank" rel="noopener noreferrer">🐦 Twitter</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>Email: support@afrostyle.com</p>
          <p>Phone: +1 (555) 123-4567</p>
          <p>Hours: 24/7 Live Market Support</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 AfroStyle. All rights reserved. Celebrating African Heritage & Fashion.</p>
      </div>
    </footer>
  );
}

export default Footer;
